export class CarouselNavigation extends HTMLElement {
  #carousel = null;
  #label = null;

  constructor() {
    super();

    this.#carousel = this.closest('via-carousel');
    this.#label = document.createElement('data');
  }

  connectedCallback() {
    this.hidden = false;

    this.classList.add('glide__arrows');
    this.setAttribute('data-glide-el', 'controls');

    this.querySelectorAll('button').forEach((button, index) => {
      button.setAttribute('data-glide-dir', index === 0 ? '<' : '>');
    });

    this.appendChild(this.#label);

    this.#carousel.addEventListener('via-carousel:update', this.#handleCarouselUpdate);
  }

  disconnectedCallback() {
    this.hidden = true;

    this.classList.add('glide__arrows');
    this.removeAttribute('data-glide-el', 'track');

    this.querySelectorAll('button').forEach((button) => {
      button.removeAttribute('data-glide-dir');
    });

    this.removeChild(this.#label);

    this.#carousel.removeEventListener('via-carousel:update', this.#handleCarouselUpdate);
  }

  update({index, total}) {
    this.#label.textContent = `${index + 1} / ${total}`;

    this.#label.setAttribute('value', index + 1);
    this.#label.setAttribute('aria-label', `Slide ${index + 1} von ${total}`);
  }

  #handleCarouselUpdate = (event) => {
    this.update({
      index: event.detail.index,
      total: event.detail.total,
    });
  }
}